import { redirect, type RouteObject } from 'react-router-dom';

export const settingsRoute: RouteObject = {
  path: 'settings',
  children: [
    {
      index: true,
      loader: () => redirect('general'),
    },
    {
      path: 'general',
      lazy: () => import('./general'),
    },
    {
      path: 'import',
      children: [
        {
          path: '',
          lazy: () => import('./import/index'),
        },
        {
          path: 'items',
          lazy: () => import('./import/item'),
        },
        {
          path: 'snapshot',
          lazy: () => import('./import/snapshot'),
        },
        {
          path: 'gifts',
          lazy: () => import('./import/gift'),
        },
        {
          path: 'season-passes',
          lazy: () => import('./import/seasonPass'),
        },
      ],
    },
  ],
};
